const webPush = 'webPush';

/** Base Fetch Actions */
export const FETCH_WEB_PUSH_RESPONSE = `${webPush}/FETCH_WEB_PUSH_RESPONSE`;
export const FETCH_WEB_PUSH_REQUEST = `${webPush}/FETCH_WEB_PUSH_REQUEST`;
export const FETCH_WEB_PUSH_ERROR = `${webPush}/FETCH_WEB_PUSH_ERROR`;

/** Base Create Actions */
export const CREATE_WEB_PUSH_RESPONSE = `${webPush}/CREATE_WEB_PUSH_RESPONSE`;
export const CREATE_WEB_PUSH_REQUEST = `${webPush}/CREATE_WEB_PUSH_REQUEST`;
export const CREATE_WEB_PUSH_ERROR = `${webPush}/CREATE_WEB_PUSH_ERROR`;

/** Base Delete Actions */
export const DELETE_WEB_PUSH_RESPONSE = `${webPush}/DELETE_WEB_PUSH_RESPONSE`;
export const DELETE_WEB_PUSH_REQUEST = `${webPush}/DELETE_WEB_PUSH_REQUEST`;
export const DELETE_WEB_PUSH_ERROR = `${webPush}/DELETE_WEB_PUSH_ERROR`;

/** Base Send Web Push Actions */
export const SEND_WEB_PUSH_RESPONSE = `${webPush}/SEND_WEB_PUSH_RESPONSE`;
export const SEND_WEB_PUSH_REQUEST = `${webPush}/SEND_WEB_PUSH_REQUEST`;
export const SEND_WEB_PUSH_ERROR = `${webPush}/SEND_WEB_PUSH_ERROR`;
